import React from 'react';
import {Helmet} from 'react-helmet';
import Progress from '../common/Progress';
import NavigationMain from '../common/NavigationMain';
import Footer from '../common/Footer';
import TopHeader from '../common/TopHeader';
import ErrorBox from '../common/ErrorBox';
import WhiteLabelCss from '../common/WhiteLabelCss';
import Filter from '../widgets/filter/Filter';
import ChatWidget from '../widgets/chat/ChatWidget';
import ShareRoutes from '../../config/routes/share';
import LoginButton from '../pages/sharedPages/LoginButton';
import { withRouter } from 'react-router';
import { correctHeight, detectBody } from './Helpers';
import MatchMediaWrapper from '../../helpers/MatchMediaWrapper';
import { filterActions } from '../../data/actions/filter';
import { Link } from 'react-router-dom';
import withSiloCode from '../../helpers/WithSiloCode';
import MissingReleasesWarning from '../pages/result/ReleaseDateWarning';

import { connect } from 'react-redux';

class Share extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isFilterOpened: false,
            filterDataCount: null,
        }
    } 
    
    toggleFilterOpened = () => {
        this.setState({
            isFilterOpened: !this.state.isFilterOpened
        });        
    }

    getFilterCount = (filterCount) => {
        this.setState({
            filterDataCount: filterCount
        })
    }    
    
    render() {
        const { loggedIn } = this.props.user;
        const { pathname } = window.location;
        const isHeartbeatsShare = pathname.includes('/reporting/heartbeats') || pathname.includes('/reporting/nosedives');
        const heartbeatsClassName = isHeartbeatsShare ? 'share-preview-heartbeats-page':''
        const isDownload = pathname.includes('/share/download');
        const downloadClassName = isDownload ? "share-download-page" : "";
        
        return (
            <div id="wrapper" className={`${this.props.silo} share-preview-page ${heartbeatsClassName} ${downloadClassName}`}>
                <ErrorBox />
                <Helmet defaultTitle="Enterlytics" titleTemplate="%s - Enterlytics" />
                <WhiteLabelCss silo={this.props.silo} />
                <div id="page-wrapper" className={`page-wrapper admin-page-wrapper`}>
                    <div className="missing-data-main-holder">
                        <MissingReleasesWarning />
                    </div>
                    <div className="share-page-wrapper-inner">
                        { isDownload ? <Link to="/" className="main-download-logo">
                            <div className="main-logo"></div>
                        </Link> : null }
                        {loggedIn && <Filter 
                            isFilterOpened={this.state.isFilterOpened}
                            toggleFilterOpened={this.toggleFilterOpened}
                            callBackFromMain={this.getFilterCount}
                            readonly={true}
                        />}
                        <LoginButton />
                        <div className="main-content-wrapper">
                            <ShareRoutes />
                        </div>
                    </div>
                </div>

            </div>

        )
    }

    componentDidMount() {
		
		this.props.dispatch(filterActions.setSharedMode());

        // Run correctHeight function on load and resize window event
        $(window).bind("load resize", function() {
            correctHeight();
            detectBody();
        });

        // Correct height of wrapper after metisMenu animation.
        $('.metismenu a').click(() => {
            setTimeout(() => {
                correctHeight();
            }, 300)
        });
    }
}

function mapStateToProps(state) {
    return { 
        user: state.user
    };
}


export default withSiloCode(withRouter(connect(mapStateToProps)(Share)))
